import { images } from "./assets";
const date = new Date();
export const en = {
  header: {
    logo: "Yingjie Shen",
    project: "Projects",
    about: "About Me",
    resume: "Resume",
  },
  about: {
    greetings: "Hello!",
    greetingsName: "I’m Yingjie Shen.",
    title: "About me",
    para1:
      "I am a graduate student major in Computer Science at University of Southern California. I earned my Bachelor’s degree of Computer Science from University of Wisconsin - Madison in 2020.",
    para2:
      "I am a very determined and priority-driven individual who excels in dealing with various challenges. I am willing to solve problems with teammates, pay attention to details and always try to finish tasks with care and perfection.",
    profile: images.about.profile,
  },
  education: {
    title: "Education",
    graduate: {
      school: "University of Southern California",
      time: "Sep 2020 – May 2022",
      major: "Master of Science: Computer and Information Sciences",
      gpa: "3.82",
    },
    undergraduate: {
      school: "University of Wisconsin - Madison",
      time: "Jan 2018 - May 2020",
      major: "Bachelor of Science: Computer and Information Sciences",
      gpa: "3.69",
    },
  },
  courses: {
    title: "Courses",
    courses: [
      "Java Programming",
      "Object-Oriented Programming",
      "Data Structures",
      "Computer Systems",
      "Discrete Mathematics",
      "Machine Organization",
      "Algorithms",
      "AI & Machine Learning",
      "Databases Systems",
      "User Experience Design",
      "Web Technologies",
      "Operating Systems",
      "Computer Networks",
      "Mobile Game Development",
    ],
  },
  experience: {
    title: "Experience",
    experience: [
      {
        company: "Laxis",
        title: "Software Engineer Intern",
        time: "Oct 2020 - Oct 2021",
        description: [
          "Responsible for web application, iOS application and Chrome extension with JavaScript, HTML5, CSS3, ReactJS and React Native.",
          "Refactored the web application with Material UI and React Router, made the application responsive on laptops and tablets, built new features that consume RESTful APIs from backend, implemented authentication, user management system and other key functionalities related to data query and mutation, and improved web application performance by 60%.",
          "Fixed bugs and implemented functionalities to support 20 additional locales and languages on Chrome extension.",
          "Refactored navigation and rebuilt UI of the iOS application based on the new Figma design and tested latest builds on TestFlight.",
          "Utilized Git and Sourcetree for source control, following Agile development methodology and CI/CD workflow.",
          "Launched web application with 200 users with a 5% daily growth rate and chosen for Google startup company.",
        ],
        path: "/projects/",
      },
      {
        company: "University of Wisconsin - Madison",
        title: "Undergraduate Research Assistant",
        time: "Apr 2019 – May 2020",
        description: [
          "Worked alongside teammates to track people's indoor positions via Internet of Things.",
          "Developed a firmware for IoT devices in C++ on Particle Photon, to scan and publish Wi-Fi signals to Particle Cloud.",
          "Developed a CLI tool in Python to access Particle Cloud to query, parse, and pre-process data for Machine Learning.",
          "Used previous data to train classification and k-nn and k-means clustering and learning models to predict future data.",
          "Built models of Wi-Fi signal distribution using decision tree and random forest, prediction up to 75%.",
        ],
      },
    ],
  },
  skills: {
    title: "Skills",
    programming: {
      label: "Programming Languages",
      content: [
        "Java",
        "JavaScript",
        "TypeScript",
        "Python",
        "Swift",
        "C",
        "SQL",
        "bash",
      ],
    },
    web: {
      label: "Web Development",
      content: [
        "HTML5",
        "CSS3",
        "React",
        "Angular",
        "Vue",
        "jQuery",
        "SASS/SCSS",
        "Bootstrap",
        "Material UI",
        "Vuetify",
        "XML",
        "JSON",
      ],
    },
    framework: {
      label: "Frameworks",
      content: [
        "Node.js",
        "Express",
        "GraphQL",
        "React Native",
        "npm",
        "yarn",
        "Webpack",
        "Flask",
        "JUnit",
        "JavaFX",
        "Cocapods",
        "Spark",
      ],
    },
    database: {
      label: "Databases",
      content: ["MongoDB", "SQLite"],
    },
    tools: {
      label: "Tooling",
      content: [
        "VS Code",
        "WebStorm",
        "Eclipse",
        "Anaconda",
        "Postman",
        "Git",
        "Sourcetree",
        "XCode",
        "Android Studio",
        "Expo",
        "TestFlight",
        "Adobe Xd",
        "Unity3D",
      ],
    },
    cloud: {
      label: "Cloud Services",
      content: [
        "Google Cloud Platform",
        "Amazon Web Services",
        "Azure",
        "Netlify",
        "DialogFlow",
      ],
    },
    languages: {
      label: "Languages",
      content: ["Chinese (Mandarin)", "English"],
    },
  },
  projects: {
    title: "Projects",
    projects: [
      {
        name: "Yingjie's Portfolio",
        time: "",
        description: "Personal projects showcase.",
        category: "web development",
        stacks: ["React"],
        form: "individual",
        demo: "https://shen92.github.io",
        github: "https://shen92.github.io",
        details: ["detail"],
        cover: images.projects.yingjiePortfolio,
        path: "/projects/yingjies-portfolio",
      },
      {
        name: "Laxis App",
        time: "",
        description: "Internship work showcase.",
        category: "web development",
        stacks: ["React"],
        form: "teamwork",
        demo: "https://www.laxis.tech",
        github: null,
        details: ["detail"],
        cover: images.projects.laxisApp,
        path: "/projects/laxis-app",
      },
      {
        name: "USC Films iOS App",
        time: "",
        description: "iOS application powered by SwiftUI.",
        category: "mobile development",
        stacks: ["SwiftUI"],
        form: "individual",
        demo: "http://express-env.eba-nreuxcka.us-west-1.elasticbeanstalk.com",
        github: "https://github.com/shen92/USC-Films-SwiftUI",
        details: ["detail"],
        cover: images.projects.uscFilmsIOS,
        path: "/projects/usc-films-ios-app",
      },
      {
        name: "Fitness Tracker Mobile App",
        time: "",
        description: "All platform app powered by React Native.",
        category: "mobile development",
        stacks: ["React Native"],
        form: "individual",
        demo: null,
        github: "https://github.com/shen92/Fitness-Tracker-React-Native",
        details: ["detail"],
        cover: images.projects.fitnessTrackerRn,
        path: "/projects/fitness-tracker-mobile-app",
      },
      {
        name: "USC Films Web App",
        time: "",
        description: "Fully responsive app powered by Angular.",
        category: "web development",
        stacks: ["Angular"],
        form: "individual",
        demo: "https://ui-shen92-uscfilms.wl.r.appspot.com",
        github: "https://github.com/shen92/USC-Films-Angular",
        details: ["detail"],
        cover: images.projects.uscFilmsAngular,
        path: "/projects/usc-films-web-app",
      },
      {
        name: "UW Course Search Web App",
        time: "",
        description: "Course search app powered by React.",
        category: "web development",
        stacks: ["React"],
        form: "individual",
        demo: "https://uw-course-search-shen92.uw.r.appspot.com/",
        github: "https://github.com/shen92/UW-Course-Search-React",
        details: ["detail"],
        cover: images.projects.uwCourseSearch,
        path: "/projects/uw-course-search-web-app",
      },
      {
        name: "Hope Island Website",
        time: "",
        description: "Official website of mobile game - Hope Island.",
        category: "web development",
        stacks: ["Vue"],
        form: "individual",
        demo: "https://gallant-keller-d302ae.netlify.app",
        github: "https://github.com/shen92/Hope-Island-Website-Vue",
        details: ["detail"],
        cover: images.projects.hopeIsialndWebsite,
        path: "/projects/hope-island-website",
      },
      {
        name: "Fitness Tracker Backend",
        time: "",
        description: "Fitness Tracker powered by MERNG stack.",
        category: "backend development",
        stacks: ["Node.js"],
        form: "individual",
        demo: "https://fitness-tracker-rest-api.uw.r.appspot.com/graphql",
        github: "https://github.com/shen92/Fitness-Tracker-Express-GraphQL",
        details: ["detail"],
        cover: images.projects.fitnessTrackerGraphql,
        path: "/projects/fitness-tracker-backend",
      },
      {
        name: "USC Films Backend",
        time: "",
        description: "Proxy server powered by Node.js.",
        category: "backend development",
        stacks: ["Node.js"],
        form: "individual",
        demo: "https://api-shen92-uscfilms.wl.r.appspot.com",
        github: "https://github.com/shen92/USC-Films-Express",
        details: ["detail"],
        cover: images.projects.uscFilmsExpress,
        path: "/projects/usc-films-backend",
      },
      {
        name: "The Movie DB",
        time: "",
        description: "Native way to search films powered by Flask.",
        category: "backend development",
        stacks: ["Flask"],
        form: "individual",
        demo: "https://shen92moviedb.azurewebsites.net",
        github: "https://github.com/shen92/USC-Films-Flask",
        details: ["detail"],
        cover: images.projects.movieDbFlask,
        path: "/projects/the-movie-db",
      },
      {
        name: "WeWish",
        time: "",
        description: "HackSC 21 competition work.",
        category: "web development",
        stacks: ["React"],
        form: "teamwork",
        demo: "https://wewish.tech",
        github: "https://github.com/shen92/WeWish",
        details: ["detail"],
        cover: images.projects.weWish,
        path: "/projects/wewish",
      },
      {
        name: "Hope Island",
        time: "",
        description: "Mobile game powered by Unity3D.",
        category: "game development",
        stacks: ["Unity3D"],
        form: "teamwork",
        demo: "https://www.youtube.com/watch?v=kx65PHULkig",
        github: "https://github.com/shen92/Hope-Island-Unity",
        details: ["detail"],
        cover: images.projects.hopeIslandGame,
        path: "/projects/wewish",
      },
      {
        name: "WiscShop ChatBot",
        time: "",
        description: "E-commerce chatbot powered by DialogFlow",
        category: "web development",
        stacks: ["DialogFlow"],
        form: "individual",
        demo: null,
        github: "https://github.com/shen92/WiscShop-Chat-Bot",
        details: ["detail"],
        cover: images.projects.wiscShopChatBot,
        path: "/projects/wiscshop-chatbot",
      },
      {
        name: "Indoor Tracking",
        time: "",
        description: "Research work at UW-Madison.",
        category: "research",
        stacks: ["IoT"],
        form: "teamwork",
        demo: null,
        github: null,
        details: ["detail"],
        cover: images.projects.indoorTracking,
        path: "/projects/indoor-tracking",
      },
      {
        name: "RN Audio Player",
        time: "",
        description: "Take-home project for internship interview.",
        category: "mobile development",
        stacks: ["React Native"],
        form: "individual",
        demo: null,
        github: "https://github.com/shen92/Audio-Player-React-Native",
        details: ["detail"],
        cover: images.projects.audioPlayer,
        path: "/projects/rn-audio-player",
      },
      {
        name: "Quiz Generator",
        time: "",
        description: "Quiz preperation app powered by JavaFX.",
        category: "desktop development",
        stacks: ["JavaFX"],
        form: "teamwork",
        demo: null,
        github: "https://github.com/shen92/Quiz-Generate-Java",
        details: ["detail"],
        cover: images.projects.quizGenerator,
        path: "/projects/quiz-generator",
      },
      {
        name: "Dependency Checker",
        time: "",
        description: "Dependency check algorithm in Java.",
        category: "other",
        stacks: ["Java"],
        form: "individual",
        demo: null,
        github: "https://github.com/shen92/Dependency-Checker-Java",
        details: ["detail"],
        cover: images.projects.dependencyChecker,
        path: "/projects/dependency-checker",
      },
      {
        name: "Introduction to Web Technologies",
        time: "",
        description: "Some demos of Web Technologies.",
        category: "web development",
        stacks: ["JavaScript"],
        form: "individual",
        demo: null,
        github: null,
        details: ["detail"],
        cover: images.projects.introWeb,
        path: "/projects/introduction-to-web-technologies",
      },
      {
        name: "Introduction to UX Design",
        time: "",
        description: "Design sections of CS639 coursework",
        category: "design",
        stacks: ["Adobe Xd"],
        form: "individual",
        demo: null,
        github: null,
        details: ["detail"],
        cover: images.projects.introUX,
        path: "/projects/introduction-to-ux-design",
      },
      {
        name: "Introduction to Database Systems",
        time: "",
        description: "Projects from CS564 coursework",
        category: "CS fundamentals",
        stacks: ["C++"],
        form: "teamwork",
        demo: null,
        github: "https://github.com/shen92/Intro-Database",
        details: ["detail"],
        cover: images.projects.introDatabase,
        path: "/projects/introduction-to-database-systems",
      },
      {
        name: "Applications of Database Systems",
        time: "",
        description: "Projects from CSCI585 coursework",
        category: "CS fundamentals",
        stacks: ["Anaconda"],
        form: "individual",
        demo: null,
        github: "https://github.com/shen92/Databse-Systems",
        details: ["detail"],
        cover: images.projects.appDataBase,
        path: "/projects/applications-of-database-systems",
      },
      {
        name: "Introduction to Computer Networks",
        time: "",
        description: "Projects from CS640 coursework",
        category: "CS fundamentals",
        stacks: ["Python"],
        form: "teamwork",
        demo: null,
        github: "https://github.com/shen92/Intro-Computer-Networks",
        details: ["detail"],
        cover: images.projects.introNetwork,
        path: "/projects/introduction-to-computer-networks",
      },
      {
        name: "Introduction to Operating Systems",
        time: "",
        description: "Projects from CS537 coursework",
        category: "CS fundamentals",
        stacks: ["Clang"],
        form: "teamwork",
        demo: null,
        github: "https://github.com/shen92/Intro-Operating-Systems",
        details: ["detail"],
        cover: images.projects.introOS,
        path: "/projects/introduction-to-operating-systems",
      },
      {
        name: "Introduction to Artificial Intelligence",
        time: "",
        description: "Projects from CS540 coursework",
        category: "CS fundamentals",
        stacks: ["Java"],
        form: "individual",
        demo: null,
        github: "https://github.com/shen92/Intro-Artificial-Intelligence",
        details: ["detail"],
        cover: images.projects.introAI,
        path: "/projects/introduction-to-artificial-intelligence",
      },
      {
        name: "Introduction to Java and OOP",
        time: "",
        description: "Projects from CS300 coursework",
        category: "CS fundamentals",
        stacks: ["Java"],
        form: "individual",
        demo: null,
        github: "https://github.com/shen92/Intro-Java-OOP",
        details: ["detail"],
        cover: images.projects.introJava,
        path: "/projects/introduction-to-java-and-oop",
      },
    ],
  },
  footer: {
    message:
      "Designed & developed by Yingjie Shen. Powered by React and Material UI.",
    copyright: `Copyright © Yingjie Shen, ${date.getFullYear()}`,
  },
};

export const links = {
  github: "https://github.com/shen92",
  linkedin: "https://www.linkedin.com/in/yingjie-shen-a814a916b",
  instagram: "https://www.instagram.com/jack_syj",
  email: "yingjies@usc.edu",
  resume:
    "https://drive.google.com/file/d/1t_3eH37fwQ_Zoo_qaSN8_9p0hGITnM2T/view",
};
